module.exports = __webpack_public_path__ + "static/img/5-EN.06a6f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_m/5-EN.png
// module id = d1s/
// module chunks = 1